import { inject, Injectable, signal } from '@angular/core';

export type ToastSeverity = 'success' | 'error' | 'warning' | 'info';
export type ToastPosition =
  | 'top-right'
  | 'top-left'
  | 'bottom-right'
  | 'bottom-left'
  | 'top-center'
  | 'bottom-center';
export interface Toast {
  id: number;
  message: string;
  description?: string;
  severity: ToastSeverity;
  duration: number;
  position: ToastPosition;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toasts = signal<Toast[]>([]);
  position = signal<ToastPosition>('top-right');
  private idCounter = 0;

  /**
   * Muestra un toast
   * @param message
   * @param description
   * @param severity
   * @param duration
   * @param position
   */
  show(
    message: string,
    description?: string,
    severity: ToastSeverity = 'info',
    duration: number = 3000,
    position?: ToastPosition | undefined,
  ) {
    // ── Deduplicación Preventiva Global ──
    const isDuplicate = this.toasts().some(
      (t) =>
        ((t.description && description && t.description.trim() === description.trim()) ||
          (t.message && message && t.message.trim() === message.trim() && (!t.description || !description))) &&
        t.severity === severity
    );

    if (isDuplicate) {
      return;
    }

    const toast: Toast = {
      id: ++this.idCounter,
      message,
      description,
      severity,
      duration,
      position: position || this.position(),
    };

    this.toasts.update((toasts) => [...toasts, toast]);

    if (duration > 0) {
      setTimeout(() => this.remove(toast.id), duration);
    }
  }

  /**
   * Elimina un toast
   * @param id
   */
  remove(id: number) {
    this.toasts.update((toasts) => toasts.filter((t) => t.id !== id));
  }

  /**
   *
   * @param position
   */
  setPosition(position: ToastPosition) {
    this.position.set(position);
  }
}
